import styled from "styled-components";
import { GRAYSCALE_500, NEUTRAL_100, PALE_BLUE, WHITE } from "@styles/colors";
import { INTER } from "@styles/fonts";
import { safeAreaInset } from "@lib/telegram";

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 12px;
  gap: 8px;
  height: 100%;
  overflow: hidden;
  position: relative;
`;

export const FixedContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SearchAndQRContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;

export const AddressListContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 16px;
  overflow-y: auto;
  padding-bottom: 100px;
`;

export const EmptyListContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 32px 12px;
  border: 1px solid ${NEUTRAL_100};
  border-radius: 18px;
`;

export const EmptyListText = styled.span`
  color: ${GRAYSCALE_500};
  margin: 16px 0;
`;

export const AddressList = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
`;

export const AddressItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  padding: 14px 12px;
  border: 1px solid ${NEUTRAL_100};
  border-radius: 10px;
  background-color: ${PALE_BLUE};
`;

export const BottomButtonContainer = styled.div`
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 16px 12px;
  padding-bottom: ${safeAreaInset().bottom || 16}px;
  border-top: 1px solid ${NEUTRAL_100};
  background-color: ${WHITE};
  z-index: 10;
`;

export const AlertTextContainer = styled.span`
  font-family: ${INTER.regular};
  color: ${GRAYSCALE_500};
  font-size: 13px;
`;

export const AlertBoldText = styled.span`
  font-family: ${INTER.bold};
  color: ${GRAYSCALE_500};
  margin-left: 4px;
`;
